import { render, staticRenderFns } from "./OnboardingPayoutPlans.vue?vue&type=template&id=4f10d2e0&"
import script from "./OnboardingPayoutPlans.vue?vue&type=script&lang=js&"
export * from "./OnboardingPayoutPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports